/**
 * Pack Builder Utilities
 * — Static helper methods and utility functions
 */

(function() {
    'use strict';

    if (typeof PackBuilder === 'undefined') {
        console.error('PackBuilder class must be defined before pack-builder-utils.js');
        return;
    }

    // Static helper methods
    PackBuilder.coerce = function(v) {
        if (v === 'true') return true;
        if (v === 'false') return false;
        const n = Number(v);
        return Number.isFinite(n) && v?.trim() !== '' ? n : v;
    };

    PackBuilder.fieldsArrayToObject = function(fields = []) {
        return fields.reduce((acc, { key, value }) => {
            acc[key] = PackBuilder.coerce(value);
            return acc;
        }, {});
    };

    PackBuilder.escapeHtml = function(s = '') {
        return String(s)
            .replace(/&/g, '&amp;')
            .replace(/</g, '&lt;')
            .replace(/>/g, '&gt;')
            .replace(/"/g, '&quot;')
            .replace(/'/g, '&#039;');
    };

    PackBuilder.formatDate = function(date, format = 'MMM D, YYYY') {
        if (!date) return '';
        if (typeof window.dayjs === 'function') {
            return window.dayjs(date).format(format);
        }
        if (typeof window.moment === 'function') {
            return window.moment(date).format(format);
        }
        // Fallback to native Date
        const d = new Date(date);
        return d.toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' });
    };

    PackBuilder.getPackStorageKey = function(packSize) {
        return `pack-builder-selections-${packSize}`;
    };

})();
